import { IVender } from "../../model/respone/user/IVender";
import { apiClient } from "../apiClient";
export const VENDER_RESOURCE = "vender";
export const venderApi = {
  SelectAll: () => apiClient.get(`${VENDER_RESOURCE}`),
  Insert: (payload: IVender) => apiClient.post(`${VENDER_RESOURCE}`, payload),
  Update: (payload: IVender) => apiClient.put(`${VENDER_RESOURCE}`, payload),
  Delete: (id: number) => apiClient.delete(`${VENDER_RESOURCE}/${id}`),
};
